import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=2f4aaeac&"
import script from "./Integrations.vue?vue&type=script&lang=ts&"
export * from "./Integrations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports